import { writable } from 'svelte/store';
import { browser } from '$app/environment';

export type DuoLang = 'es' | 'en';

const initialLang: DuoLang = browser 
    ? ((localStorage.getItem('duo_lang') as DuoLang) || (navigator.language.startsWith('es') ? 'es' : 'es'))
    : 'es';

export const duoLang = writable<DuoLang>(initialLang);

export const setDuoLang = (lang: DuoLang) => {
    duoLang.set(lang);
    if (browser) {
        localStorage.setItem('duo_lang', lang);
    }
};
